import { Injectable } from '@angular/core';
import { UsersFacade } from '@app/shared/+state/users';
import { PosthogFeatureFlag } from '@app/shared/interfaces';
import { PosthogService } from '@app/shared/services/posthog/posthog.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SentimentAnalysisService {
  public enabled$ = new BehaviorSubject<boolean>(false);

  constructor(
    private posthog: PosthogService,
    private readonly usersFacade: UsersFacade
  ) {
    combineLatest([
      this.usersFacade.isOnLegacyPlan$,
      this.usersFacade.mogulAiEntitlement$,
      this.posthog.featureEnabled$(PosthogFeatureFlag.SentimentAnalysis),
    ])
      .pipe(
        map(([isOnLegacyPlan, mogulAiEntitlement, isSentimentAnalysisEnabled]) => !isOnLegacyPlan || mogulAiEntitlement?.available || isSentimentAnalysisEnabled),
        shareReplay(1) // Cache the latest value and share it among all subscribers
      )
      .subscribe((enabled) => this.enabled$.next(enabled));
  }
}
